export default __webpack_public_path__ + "assets/copy.baa10e14.svg";